import Vue from 'vue';
import Storage from 'vue-ls';
import Config from '@/config/variables';

const options = {
  namespace: Config.StorageNamespace,
  name: Config.StorageName,
  storage: Config.StorageType,
};

export default () => {
  Vue.use(Storage, options);
};
